import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { useLabels, useRequestData, useSitemap } from 'wsm-common-data';
import { trackEvent } from 'ddc-track-event';
import { FiltersContext } from '../contexts';
import { viewInventoryEvent } from '../utils/wueTracking';

const EmptyState = ({ type }) => {
	const labels = useLabels();
	const sitemap = useSitemap();
	const { clearAll } = useContext(FiltersContext);
	const { widgetName, windowId } = useRequestData();

	const viewInventoryLabel = labels.get('INCENTIVES_VIEW_INVENTORY');

	const handleViewInventoryClick = useCallback(() => {
		trackEvent(
			widgetName,
			windowId,
			viewInventoryEvent({
				label: viewInventoryLabel,
				originView: 'default'
			})
		);
	}, [widgetName, windowId, viewInventoryLabel]);

	if (type === 'noResults') {
		const noResultsLabel = labels.get('INCENTIVES_NO_RESULTS');
		const clearLabel = labels.get('INCENTIVES_CLEAR_FILTERS');
		return (
			<div
				role="status"
				aria-live="polite"
				className="empty-state text-center py-5 d-flex flex-column align-items-center gap-3"
			>
				<h2 className="ddc-font-size-xlarge">{noResultsLabel}</h2>
				<button
					type="button"
					className="btn btn-link"
					onClick={clearAll}
				>
					{clearLabel}
				</button>
			</div>
		);
	}

	const noIncentivesLabel = labels.get('INCENTIVES_NO_INCENTIVES');
	const contactDealerLabel = labels.get('INCENTIVES_CONTACT_DEALER');

	const inventoryUrl =
		sitemap.get('INVENTORY_LISTING_DEFAULT_AUTO_NEW') || '#';
	const contactUrl = sitemap.get('CONTACT_DEFAULT') || '#';

	return (
		<div
			role="status"
			aria-live="polite"
			className="empty-state text-center py-5 d-flex flex-column align-items-center gap-3"
		>
			<h2 className="ddc-font-size-xlarge text-primary">
				{noIncentivesLabel}
			</h2>
			<div className="d-flex gap-3 flex-column flex-md-row">
				<a
					href={inventoryUrl}
					className="btn btn-primary btn-lg"
					onClick={handleViewInventoryClick}
				>
					{viewInventoryLabel}
				</a>
				<a
					href={contactUrl}
					className="btn btn-outline-secondary btn-lg"
				>
					{contactDealerLabel}
				</a>
			</div>
		</div>
	);
};

EmptyState.propTypes = {
	type: PropTypes.string
};

export default EmptyState;
